export interface AppConfig {
  /** App environment name */
  environment: string;
  /** Git commit SHA (only defined from pipelines) */
  commitSha?: string;
  /** Whether app is running in development */
  development: boolean;
  links: {
    api: string;
  };
  /** Whether app is running in production */
  production: boolean;
}

const production = import.meta.env.PROD;
const apiUrl = import.meta.env.VITE_API_URL;
const appEnvironment = import.meta.env.VITE_APP_ENVIRONMENT ?? "development";

if (!apiUrl) {
  throw new Error("API url not configured");
}

export const appConfig: AppConfig = {
  environment: appEnvironment,
  commitSha: import.meta.env.VITE_GIT_SHA?.slice(0, 8),
  development: !production,
  links: {
    api: apiUrl,
  },
  production,
};
